import { render, staticRenderFns } from "./DownloadReport.vue?vue&type=template&id=228a0cf4&scoped=true"
import script from "./DownloadReport.vue?vue&type=script&lang=js"
export * from "./DownloadReport.vue?vue&type=script&lang=js"
import style0 from "./DownloadReport.vue?vue&type=style&index=0&id=228a0cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228a0cf4",
  null
  
)

export default component.exports